import { createContext, useMemo, useState } from 'react';
import cx from 'classnames';
import { Button } from 'reactstrap';
import { useToggleMap } from '../../hooks/useToggleMap';

export const SectionHeader = ({ title, icon, onClick = () => {} }) => (
  <Button
    tag="h4"
    color="text"
    className="d-flex align-items-center mb-2 p-0"
    onClick={onClick}
  >
    {icon}
    <div className={cx({ 'ml-3': !!icon })}>{title}</div>
  </Button>
);

const PANEL_VISIBILITY_INIT_STATE = {
  summary: true,
  crops: true,
  layers: true,
  sections: true,
  notes: true,
  soilLegend: true,
};

/**
 * Manages "print mode", where certain elements are hidden, and panel visibility.
 */
export const FieldsPreviewContext = createContext({});

export const FieldsPreviewContextProvider = ({ children }) => {
  const [isPrintMode, setIsPrintMode] = useState(false);
  const togglePrintMode = () => setIsPrintMode((current) => !current);

  // SHOW/HIDE PANELS
  const {
    state: panelVisibility,
    toggle: togglePanelVisibility,
    reset: resetPanelVisibility,
  } = useToggleMap(PANEL_VISIBILITY_INIT_STATE);

  const value = useMemo(
    () => ({
      isPrintMode,
      setIsPrintMode,
      togglePrintMode,
      panelVisibility,
      togglePanelVisibility,
      resetPanelVisibility,
    }),
    [isPrintMode, panelVisibility, resetPanelVisibility, togglePanelVisibility],
  );

  return (
    <FieldsPreviewContext.Provider value={value}>
      {children}
    </FieldsPreviewContext.Provider>
  );
};
